import { Injectable } from "@angular/core";
import { EmptySearchParamsFilterModel } from "../../../../../../shared/models/search/params/filters/empty-search-params-filter.model";
import { ProductsParamsFilter } from "../../../../../models/search-params/filters/products-params-filter";
import { ProductsFilterFormService } from "../products-filter-form.service";

@Injectable({
    providedIn: "root"
})
export class ProductParamsFilterFactoryServices {
    public constructor(
        private filterService: ProductsFilterFormService
    ) {
    }

     public createFilter(initialState: EmptySearchParamsFilterModel = null, searchText: string = null): ProductsParamsFilter {
        const sourceParams = initialState as ProductsParamsFilter;

        const filter = new ProductsParamsFilter(
            sourceParams.collectionGroup || this.filterService.getDefaultCollectionGroup(),
            sourceParams.collection || this.filterService.getDefaultCollection(),
            sourceParams.facets || {},
            sourceParams.sorting || this.filterService.getDefaultSortingOption(searchText),
        );

        if(this.filterService.isSingleCollectionGroup(filter.collectionGroup)) {
            filter.collection = this.filterService.getCollectionForSingleCollectionGroup(filter.collectionGroup);
        }

        return filter;
    }
}
